import produce from "immer";
import types from "./types";

function addQueuedPatch(updateAction) {
  return {
    type: types.ADD_QUEUED_PATCH,
    payload: updateAction,
  };
}

function patchWithServerId(effect, serverId) {
  return {
    type: types.PATCH_WITH_SERVER_ID_START,
    meta: {
      offline: {
        effect: { ...effect, id: serverId },
        commit: { type: types.PATCH_WITH_SERVER_ID_COMMIT },
      },
    },
  };
}

function unlisten(commitAction, localId) {
  return {
    type: types.UNLISTEN,
    payload: { commitAction, localId },
  };
}

function unlistenAll() {
  return {
    type: types.UNLISTEN_ALL,
  };
}

const initialState = {
  listenedToActions: {},
  status: "idle",
};

export default function waitForIdReducer(state = initialState, action) {
  switch (action.type) {
    case types.ADD_QUEUED_PATCH:
      const payload = action.payload;
      if (!payload.dependsOn) {
        console.warn(
          "dependsOn should be a commit action. Instead got ",
          payload.dependsOn
        );
        return state;
      }
      const newState = produce(state, (draftState) => {
        const ltoa = draftState.listenedToActions;
        console.log("payload in ADD_QUEUED_PATCH: ", payload);
        if (!ltoa[payload.dependsOn]) {
          ltoa[payload.dependsOn] = {
            [payload.localId]: payload.effect,
          };
        } else if (!ltoa[payload.dependsOn][payload.localId]) {
          ltoa[payload.dependsOn][payload.localId] = payload.effect;
        } else {
          Object.assign(
            ltoa[payload.dependsOn][payload.localId].json,
            payload.effect.json
          );
        }
      });
      console.log("newState in wait for Id reducer: ", newState);
      return newState;

    case types.PATCH_WITH_SERVER_ID_START:
      return { ...state, status: "pending" };

    case types.PATCH_WITH_SERVER_ID_COMMIT:
      return { ...state, status: "idle" };

    case types.UNLISTEN:
      const { localId, commitAction } = action.payload;
      return produce(state, (draftState) => {
        delete draftState.listenedToActions[commitAction][localId];
        if (
          Object.keys(draftState.listenedToActions[commitAction]).length === 0
        ) {
          delete draftState.listenedToActions[commitAction];
        }
      });

    case types.UNLISTEN_ALL:
      return produce(state, (draftState) => {
        draftState.listenedToActions = {};
      });

    default:
      return state;
  }
}

function updateAndOrQueue({ id, effect, updateAction, dispatch, dependsOn }) {
  console.log(
    "updateAndOrQueue({id, effect, updateAction, dispatch, dependsOn}: ",
    { id, effect, updateAction, dispatch, dependsOn }
  );
  if (typeof id === "string" && id.slice(0, 7) === "unsaved") {
    dispatch({ ...updateAction, meta: {} });
    return dispatch(
      addQueuedPatch({
        effect: effect,
        dependsOn: dependsOn,
        localId: id,
      })
    );
  } else {
    return dispatch(updateAction);
  }
}

export { updateAndOrQueue, patchWithServerId, unlisten, unlistenAll };
